const player = $('.blogpost__posts-player');

if (player.length) {
  const podcastCode = player.data('player-code');
  const podcastUrl = `https://www.podcastone.com/episodewidget?episodeID=${podcastCode}&amp;logo=true`;
  const podcastIframe = `<iframe async src="${podcastUrl}" width="100%" height="70" frameborder="0" scrolling="no">`;

  player.append(podcastIframe);
}